import { render, staticRenderFns } from "./emailSendout.vue?vue&type=template&id=8cf23dd4&scoped=true"
import script from "./emailSendout.vue?vue&type=script&lang=js"
export * from "./emailSendout.vue?vue&type=script&lang=js"
import style0 from "./emailSendout.vue?vue&type=style&index=0&id=8cf23dd4&prod&scoped=true&lang=scss"
import style1 from "./emailSendout.vue?vue&type=style&index=1&id=8cf23dd4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cf23dd4",
  null
  
)

export default component.exports